// components/BirthdatePicker.jsx
import React, { useRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { subYears } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./CustomDatePicker.scss";

const CustomDatePicker = ({ date, setDate }) => {
  const [showPicker, setShowPicker] = useState(false);
  const calendarRef = useRef(null);
  const inputRef = useRef(null);

  const handleDateChange = (date) => {
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    setDate(`${month}/${day}/${year}`);
    setShowPicker(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setShowPicker(false);
      }
    }

    if (showPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPicker]);

  return (
    <>
      <input
        ref={inputRef}
        type="text"
        value={date}
        readOnly
        onClick={() => setShowPicker(true)}
      />
      <span
        className="calendar-icon"
        onClick={() => setShowPicker((prev) => !prev)}
        style={{ cursor: "pointer" }}
      >
        📅
      </span>

      {showPicker && (
        <div
          ref={calendarRef}
          style={{
            position: "absolute",
            right: 0,
            top: "110%",
            zIndex: 9999,
          }}
        >
          <DatePicker
            selected={date ? new Date(date) : null}
            onChange={handleDateChange}
            inline
            minDate={new Date()}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </div>
      )}
    </>
  );
};

export default CustomDatePicker;
